/** Near-black behind the AI Series modules, from the design; not a CDS color token. */
export const AI_SERIES_BACKGROUND_COLOR = '#0F1114';

/** Statsig gate that keeps the phase 1 series running once their campaign ends (MERCH-3740). */
export const AI_SERIES_PHASE_1_GATE = 'ai-series-mvp-phase-1-feature-gate';

/** Statsig gate that releases the phase 2 series (MERCH-3730). */
export const AI_SERIES_PHASE_2_GATE = 'ai-series-mvp-phase-2-feature-gate';

/** The series live before phase 2; any other series the endpoint returns is a phase 2 series. */
export const PHASE_1_SERIES_SLUGS: ReadonlySet<string> = new Set([
  'ai-data-analytics',
  'ai-business-leadership',
  'ai-software-development',
  'ai-cybersecurity',
]);
